// 🎯 Flat, ordered list of attestation clauses. Expected to grow over time —
// each clause is its own timestamped signature record (Corp.Z_04_RepresentativeAttestation),
// never a single "I agree" checkbox. Add new clauses by appending here; existing
// signed rows for prior clauses are unaffected.
export const ATTESTATION_CLAUSES = [
  {
    key: "AUTHORITY_TO_REPRESENT",
    text: "I confirm that I have the authority to represent this company for the purposes of ESG disclosure reporting on Sustina.",
  },
  {
    key: "ACCURACY_OF_INFORMATION",
    text: "I confirm that the information I provide on behalf of this company is accurate to the best of my knowledge.",
  },
  {
    key: "IDENTITY_CONFIRMATION",
    text: "I confirm that the full name and date of birth I have provided are my own and correct.",
  },
];
